import { http } from "./http";

// Public password flows do not attach a login token or invoke the auth refresh interceptor.
async function publicRequest(path, data) {
  const response = await fetch((process.env.REACT_APP_API_URL || "").replace(/\/$/, "") + "/api/auth/" + path, {
    method: "POST", credentials: "omit", referrerPolicy: "no-referrer",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  });
  if (!response.ok) {
    const message = response.status === 429 ? "Demasiados intentos. Espera unos minutos antes de volver a intentar."
      : path === "recovery" ? "No se pudo solicitar el enlace. Inténtalo de nuevo."
      : response.status >= 500 ? "El servicio no está disponible. Inténtalo de nuevo."
      : "El enlace no es válido, ya fue utilizado o ha caducado. Solicita uno nuevo.";
    throw new Error(message);
  }
  return response.status === 204 ? null : response.json();
}
export const requestRecovery = email => publicRequest("recovery", { email: email.trim() });
export const inspectAccess = token => publicRequest("access/inspect", { token });
export const completeAccess = (token, password) => publicRequest("access/complete", { token, password });
export const getAccountAccess = async id => (await http.get("/users/" + id + "/access")).data;
export const resendAccountAccess = async id => (await http.post("/users/" + id + "/access/resend")).data;
